import React from 'react';  
import ImprimirTicket from '../../components/balanza/ImprimirBalanza';

const ImprimirTicketBalanza: React.FC = () => {
  return (
    <ImprimirTicket />
  );
};

export default ImprimirTicketBalanza;